import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { InputWithMargin } from "../../editor/Input";
import { MenuCard } from "../../menu/MenuCard";
import { MapElementSelectionDetail } from "./components/MapElementSelectionDetail";
import { MapElementFilter } from "../../../helper/MapElementFilter";
import { MapElementReferenceModel } from "../../../../shared/action/MapElementReferenceModel";
import { Slider, SliderThumb, SliderTrack } from "../../editor/Slider";
import { extendedMapMarkerValueModelTypesArray } from "../../../../shared/action/ValueModel";
const Container = styled.div.withConfig({
  displayName: "SetCameraActionDetails__Container",
  componentId: "sc-jbae0y-0"
})(["width:100%;"]);
const OptionHeader = styled.div.withConfig({
  displayName: "SetCameraActionDetails__OptionHeader",
  componentId: "sc-jbae0y-1"
})(["display:flex;flex-direction:row;"]);
const InfoContainer = styled.div.withConfig({
  displayName: "SetCameraActionDetails__InfoContainer",
  componentId: "sc-jbae0y-2"
})(["margin:4px;font-size:small;max-width:250px;"]);
const HeaderText = styled.div.withConfig({
  displayName: "SetCameraActionDetails__HeaderText",
  componentId: "sc-jbae0y-3"
})(["cursor:pointer;margin-top:2px;margin-left:4px;"]);
const SliderContainer = styled.div.withConfig({
  displayName: "SetCameraActionDetails__SliderContainer",
  componentId: "sc-jbae0y-4"
})(["display:flex;flex-direction:row;margin:8px;align-items:center;justify-content:center;flex-grow:1;"]);
const SliderLabel = styled.div.withConfig({
  displayName: "SetCameraActionDetails__SliderLabel",
  componentId: "sc-jbae0y-5"
})(["margin:4px;"]);
export const SetCameraActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  const zoomEnabled = action.targetZoomFactor > -1;

  function onZoomEnabledClicked() {
    if (action.targetZoomFactor < 0) action.setTargetZoomFactor(0.5);else action.setTargetZoomFactor(-1);
  }

  function onTargetEnabledClicked() {
    if (action.targetLocation == null) action.setTargetLocation(new MapElementReferenceModel({}));else action.setTargetLocation(null);
  }

  function onReturnToMainCameraClicked() {
    action.setReturnToMainCamera(!action.returnToMainCamera);
  }

  function onZoomSliderChange(sliderValue) {
    action.setTargetZoomFactor(sliderValue);
  }

  function onSpeedSliderChange(sliderValue) {
    action.setCameraMovementSpeedFactor(sliderValue);
  }

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(OptionHeader, {
    onClick: onTargetEnabledClicked
  }, /*#__PURE__*/React.createElement(InputWithMargin, {
    type: "checkbox",
    checked: action.targetLocation != null,
    onChange: e => {}
  }), /*#__PURE__*/React.createElement(HeaderText, null, t("action_editor.node_set_camera_target"))), action.targetLocation && /*#__PURE__*/React.createElement(MapElementSelectionDetail, {
    name: "",
    selectedElement: action.targetLocation,
    elementSetter: action.setTargetLocation.bind(action),
    parameterTypes: extendedMapMarkerValueModelTypesArray,
    getSelectableElements: MapElementFilter.filterExtendedMapMarkerLabels
  })), /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(OptionHeader, {
    onClick: onZoomEnabledClicked
  }, /*#__PURE__*/React.createElement(InputWithMargin, {
    type: "checkbox",
    checked: zoomEnabled,
    onChange: e => {}
  }), /*#__PURE__*/React.createElement(HeaderText, null, t("action_editor.node_set_camera_zoom") + (zoomEnabled ? ": " + Math.floor(action.targetZoomFactor * 100) + "%" : ""))), zoomEnabled && /*#__PURE__*/React.createElement(SliderContainer, null, /*#__PURE__*/React.createElement(SliderLabel, null, t("action_editor.node_set_camera_zoom_near")), /*#__PURE__*/React.createElement(Slider, {
    value: action.targetZoomFactor,
    min: 0.01,
    max: 1,
    step: 0.01,
    renderTrack: SliderTrack,
    renderThumb: SliderThumb,
    onChange: onZoomSliderChange
  }), /*#__PURE__*/React.createElement(SliderLabel, null, t("action_editor.node_set_camera_zoom_far")))), /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(OptionHeader, {
    onClick: onReturnToMainCameraClicked
  }, /*#__PURE__*/React.createElement(InputWithMargin, {
    type: "checkbox",
    checked: action.returnToMainCamera,
    onChange: e => {}
  }), /*#__PURE__*/React.createElement(HeaderText, null, t("action_editor.node_set_camera_return_to_main"))), action.returnToMainCamera && /*#__PURE__*/React.createElement(InfoContainer, null, t("action_editor.node_set_camera_return_to_main_active_info")), !action.returnToMainCamera && /*#__PURE__*/React.createElement(InfoContainer, null, t("action_editor.node_set_camera_return_to_main_inactive_info"))), /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(OptionHeader, null, /*#__PURE__*/React.createElement(HeaderText, null, t("action_editor.node_set_camera_movement_speed") + ": " + (action.cameraMovementSpeedFactor < 1 ? Math.floor(action.cameraMovementSpeedFactor * 100) + "%" : t("action_editor.node_set_camera_movement_immediate")))), /*#__PURE__*/React.createElement(SliderContainer, null, /*#__PURE__*/React.createElement(SliderLabel, null, t("action_editor.node_set_camera_movement_slow")), /*#__PURE__*/React.createElement(Slider, {
    value: action.cameraMovementSpeedFactor,
    min: 0.01,
    max: 1,
    step: 0.01,
    renderTrack: SliderTrack,
    renderThumb: SliderThumb,
    onChange: onSpeedSliderChange
  }), /*#__PURE__*/React.createElement(SliderLabel, null, t("action_editor.node_set_camera_movement_fast")))));
});